
import 'gridstack/dist/gridstack.min.css';


const ResponsiveImageGrid = () => {


  return (
    <div className='flex flex-col items-center justify-center h-screen'>
 <div className='ImageGrid grid grid-cols-15 grid-rows-8 gap-4  h-[80vh] w-11/12 '>
      <div className='col-span-6 '><label className='text-6xl text-right font-bold'>Activities </label></div>
      <div className='row-span-5 col-span-3'>
        <img src='/imageGridBanner/3.jpg' alt='Web 12' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-6'>
          <label className='text-6xl text-left font-bold'>Gallery</label>
      </div>
      <div className='row-span-3'>
        <label className='text-6xl text-left font-bold z-0 transform -rotate-90'>Travel</label>
      </div>
      <div className=''></div>
      <div className='bg-[#A1A9FF] m-[2px] rounded-md'></div>
      <div className='col-span-3 row-span-2'>
        <img src='/imageGridBanner/2.png' alt='Student group photo' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-5 row-span-2'>
        <img src='/imageGridBanner/4.png' alt='Milton Hershey school students in classroom' className='w-full h-full object-cover' />
      </div>
      <div className='row-span-2'> 
        <label className='text-5xl text-left font-bold transform -rotate-90'>Sports</label>
      </div>  
      <div className='col-span-2 row-span-2'>
        <img src='/imageGridBanner/1.png' alt='DSC05947' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-3 row-span-5 mb-4'>
        <img src='/imageGridBanner/6.png' alt='iStock crop' className='w-full h-full object-cover' />

      </div>
      <div className='col-span-3 row-span-5 mb-4'>
        <img src='/imageGridBanner/8.jpeg' alt='Staffroom' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-3 row-span-3'>
        <img src='/imageGridBanner/9.png' alt='Alternative protein course database header' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-3 row-span-3'>
        <img src='/imageGridBanner/5.png' alt='Banner 1' className='w-full h-full object-cover' />
      </div>
      <div className='col-span-3 row-span-3'>
        <img src='/imageGridBanner/7.png' alt='iStock photo' className='w-full h-full object-cover' />

      </div>
      <div className='bg-[#EB7272]'>
      </div>
      <div className='col-span-2 row-span-2'>   
        <label className='text-3xl text-left font-bold '>Smart Classrooms</label>
      </div>
      <div className='col-span-2'>          
        <label className='text-xl text-left font-bold '>Extracurricular Excellence</label>
      </div>

      <div className='bg-[#99DF38]'></div>
    </div>
    </div>
   
  );
};

export default ResponsiveImageGrid;